import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  ViewChild,
} from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { RequisitionAdditionalCopy } from '../../../../../shared/models/ocl/requisition-additional-copy';

const faxPattern = /^\d*$/;

@Component({
  selector: 'app-additional-copies',
  templateUrl: './additional-copies.component.html',
  styleUrls: ['./additional-copies.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AdditionalCopiesComponent implements AfterViewInit {
  @ViewChild('container', {static: true}) public containerDiv?: ElementRef;
  @ViewChild('controls', {static: true}) public controlsDiv?: ElementRef;
  public type = 'EMAIL';
  @Input() public maxHeight: string | number = '100%';
  public gridHeight: string | number = '100%';
  public faxPattern: RegExp = faxPattern;
  public selectedKeys: any[] = [];

  public formGroup = this.fb.group({
    typeControl: ['EMAIL'],
    destinationControl: ['', [Validators.required]],
  }, {
    validators: [this.validateDestination],
  });
  @Input() public additionalCopiesControl: FormControl = new FormControl();

  constructor(private fb: FormBuilder, private ref: ChangeDetectorRef) {
    this.validateDestination = this.validateDestination.bind(this);
  }

  public validateDestination(fg: FormGroup): { [key: string]: boolean } | null {
    return fg.get('typeControl')?.value === 'FAX' && !faxPattern.test(fg.get('destinationControl')?.value) ? { pattern: true } : null;
  }

  public get IsEmail(): boolean {
    return this.formGroup.get('typeControl')?.value === 'EMAIL';
  }

  public get IsFax(): boolean {
    return this.formGroup.get('typeControl')?.value === 'FAX';
  }

  public add() {
    if (this.formGroup.get('destinationControl')?.valid) {
      const additionalCopy = {
        destination: this.formGroup.get('destinationControl')?.value,
        type: this.formGroup.get('typeControl')?.value,
      } as RequisitionAdditionalCopy;

      (this.additionalCopiesControl.value as RequisitionAdditionalCopy[]).push(additionalCopy);

      this.formGroup.get('destinationControl')?.reset('');
      this.selectedKeys = [];
    }
    this.refresh();
  }

  public remove() {
    const additionalCopies = (this.additionalCopiesControl.value as RequisitionAdditionalCopy[]);
    const indexes = this.selectedKeys.map(item => additionalCopies.findIndex(ac => ac.destination === item.destination));
    indexes.forEach(index => additionalCopies.splice(index, 1));
    this.additionalCopiesControl.setValue(additionalCopies);

    this.selectedKeys = [];
    this.refresh();
  }

  public refresh() {
    if (this.ref) {
      this.ref.detectChanges();
    }
  }

  ngAfterViewInit(): void {
    if (typeof this.maxHeight === 'number' && this.controlsDiv) {
      this.gridHeight = this.maxHeight - this.controlsDiv.nativeElement.clientHeight - 32;
    } else {
      this.gridHeight = '100%';
    }
  }
}
